<template>
  <vuescalebox :width="1920" :height="1080">
    <div class="box">
      <div class="header-box">
        <el-select v-model="form.type">
          <i class="el-icon-caret-bottom" slot="suffix"></i>
          <el-option label="首页" value="city"></el-option>
          <el-option label="主体信息" value="base"></el-option>
          <el-option label="信用红黑榜" value="rank"></el-option>
          <el-option label="绿色、地标、名特优新产品" value="recommand"></el-option>
        </el-select>
        <div class="header-right">
          <div class="info">
            <span>{{ time }}</span>
            <span>{{ userName }}</span>
          </div>
          <div class="right-btn" @click="toggleFullScreen">全屏</div>
          <div class="right-btn out" @click="loginOut">退出</div>
        </div>
      </div>
      <div class="content-box">
        <div class="info-box" v-if="form.type == 'city'">
          <leftContent :cityInfo="CityInfo"></leftContent>
        </div>
        <div class="info-box">
          <cityContent @getCode="getCode" @changePage="changePage" ref="cityComponent" :type="form.type"
            :deletion="deletion" @changeLocation="changeLocationFun" :oldLocation="changeLocation"></cityContent>
        </div>
        <div class="info-box" v-show="form.type == 'city'">
          <rightContent @setData="setData" :cityInfo="CityInfo"></rightContent>
        </div>
        <!-- 主题信息 -->
        <div class="info-box" style="flex:1;max-width:100%;" v-if="form.type == 'base' && !currentDetail">
          <rightContent2 :cityInfo="CityInfo" @showDetail="showRightContent5"></rightContent2>
        </div>
        <!-- 红黑榜 -->
        <div class="info-box" style="flex:1;max-width:100%;" v-if="form.type == 'rank'">
          <rightContent3 :cityInfo="CityInfo"></rightContent3>
        </div>
        <!-- 推荐列表 -->
        <div class="info-box" style="flex:1;max-width:100%;" v-if="form.type == 'recommand'">
          <rightContent4 :cityInfo="CityInfo"></rightContent4>
        </div>
        <div class="info-box" style="flex:1;max-width: 100%;" v-if="form.type == 'base' && currentDetail">
          <rightContent5 :cityInfo="CityInfo" :currentDetail="currentDetail" @handleClick="backFromRightContent5">
          </rightContent5>
        </div>
      </div>
      <!-- <div class="city-box">
        <cityContent></cityContent>
      </div> -->

      <!-- 主体信息 -->
      <!-- <div class="content-box" v-if="form.type == 'base'">
          <div class="info-box"></div>
          <div class="info-box" style="flex:1;max-width:100%;">
            <rightContent2></rightContent2>
          </div>
       </div> -->
      <!-- 信用红黑榜 -->
      <!-- <div class="content-box" v-if="form.type == 'rank'">
          <div class="info-box">
            <cityContent></cityContent>
          </div>
          <div class="info-box" style="flex:1;max-width:100%;">
            <rightContent3></rightContent3>
          </div>
        </div> -->
    </div>
  </vuescalebox>
</template>

<script>
import time from "@/utils/timeAction"
import Vue from "vue"
import vuescalebox from "vue2-scale-box"
import cityContent from "@/components/city.vue"
import leftContent from "@/components/leftBox/index.vue"
import rightContent from "@/components/rightBox/index.vue"
import rightContent2 from "@/components/rightBox/two.vue"
import rightContent3 from "@/components/rightBox/three.vue"
import rightContent4 from "@/components/rightBox/four.vue"
import rightContent5 from "@/components/rightBox/five.vue"
export default {
  name: "HomeView",
  components: {
    vuescalebox,
    cityContent,
    leftContent,
    rightContent,
    rightContent2,
    rightContent3,
    rightContent5,
    rightContent4
  },
  data() {
    return {
      form: {
        type: "city"
      },
      CityInfo: {},
      timer: null,
      time: "",
      changeLocation: [],
      savedMapState: null, // 用于在全局范围内保存地图状态
      deletion: {},
      currentDetail: null
    };
  },
  watch: {
    'form.type': {
      handler(newVal, oldVal) {
        if (newVal !== 'base') {
          this.currentDetail = null
        }
        // 当类型切换时，确保地图组件状态保持
        if (newVal !== oldVal && this.$refs.cityComponent) {
          // 强制更新地图组件
          this.$nextTick(() => {
            this.$refs.cityComponent.changeMap();
          });
        }
      }
    }
  },
  computed: {
    userName: function () {
      return localStorage.getItem('userName') || '管理员'
    }
  },
  mounted() {
    this.getDate()
  },
  destroyed() {
    clearInterval(this.timer)
    this.timer = null;
  },
  methods: {
    changePage() {
      if (this.form.type != 'base') {
        this.form.type = 'base'
      }
    },
    showRightContent5(data) {
      this.currentDetail = data || null
    },
    backFromRightContent5() {
      this.currentDetail = null
    },
    setData(data) {
      console.log("update")
      this.deletion = data;
    },
    changeLocationFun(e) {
      this.changeLocation = e || []
    },
    loginOut() {
      localStorage.removeItem('userName')
      localStorage.removeItem('token')
      this.$router.push({ path: '/login' })
      clearInterval(this.timer)
      this.timer = null;

    },
    toggleFullScreen() {
      const docEl = document.documentElement; // 获取文档根元素

      if (document.fullscreenElement) { // 检测当前是否处于全屏状态
        document.exitFullscreen(); // 如果是全屏，则退出全屏
      } else {
        docEl.requestFullscreen(); // 如果不是全屏，则进入全屏
      }
    },
    getCode(data) {
      this.CityInfo = data || {};
    },
    getDate() {
      this.time = time.getTime(new Date())
      this.timer = setInterval(() => {
        this.time = time.getTime(new Date())
      }, 1000)
    }
  }
};
</script>
<style lang="scss">
.box {

  .el-select,
  .el-input__inner {
    height: 30px !important;
    background: none !important;
    width: 260px !important;
    border-color: rgba(0, 252, 255, 1) !important;
    border-radius: 0 !important;
  }

  .el-input__inner {
    color: rgba(255, 255, 255, 0.90) !important;
    font-size: 14px !important;
    font-weight: 400;
  }

  .el-select__caret::before {
    visibility: hidden;
    /* 隐藏默认图标 */
  }

  .el-select__caret {
    background: url("../assets/imgs/arrow_bottom.png") no-repeat center center;
    background-size: 16px 16px;
    transform: rotate(0) !important;
    /* 取消旋转动画 */
    opacity: 0.7;
  }
}
</style>
<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: url("../assets/map-bg.png") no-repeat;
  background-size: 100% 100%;

  .header-box {
    height: 92px;
    min-height: 92px;
    width: 100%;
    display: flex;
    padding: 8px 16px 0 16px;
    background: url("../assets/imgs/header_bg.png") no-repeat;
    background-size: 100% 100%;
    background-position: 0%;
    box-sizing: border-box;

    .header-right {
      flex: 1;
      height: 50%;
      display: flex;
      justify-content: flex-end;

      .info {
        display: flex;
        margin-top: 5px;

        span {
          color: rgba(221, 253, 255, 0.85);
          font-size: 18px;
          font-weight: bold;

          &:nth-of-type(2) {
            margin: 0 20px;
          }
        }
      }

      .right-btn {
        width: 92px;
        height: 31px;
        color: rgba(221, 253, 255, 0.85);
        font-size: 16px;
        padding-left: 16px;
        text-align: center;
        cursor: pointer;
        line-height: 31px;
        background: url("../assets/imgs/base/all_page.png") no-repeat;
        background-size: 100% 100%;
        box-sizing: border-box;
      }

      .out {
        background: url("../assets/imgs/base/out.png") no-repeat !important;
        margin-left: 10px;
      }
    }
  }

  .city-box {
    width: 640px;
    height: 100%;
    margin: 0 auto;
  }

  .content-box {
    width: 100%;
    flex: 1;
    display: flex;
    align-items: center;

    .info-box {
      flex: 1;
      max-width: 640px;
      height: 100%;
      box-sizing: border-box;
    }
  }
}
</style>
